import { IconButton } from '@mui/material';
import { styled } from '@mui/system';

const IconButtonOutlined = styled(IconButton)(({ theme }) => ({
  boxShadow: 'inset 0px 0px 1px 1px',
  filter: 'drop-shadow(0px 0px 8px rgba(0, 0, 0, 0.1))',
})) as typeof IconButton;

export default IconButtonOutlined;
